export default (props, request) => {
    const getMarketRank = async () => {
        const data = {
            sort_id: props.sort_id,
            market_id: props.market_id,
            lang: props.language,
            count: props.count,
            increaseType: props.increaseType,
        };
        try {
            return await request.get('get-rank-list', data);
        } catch (err) {
            console.error('market-rank', err);
        }
    };

    return {
        getMarketRank
    };
};
